import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

export const Searchbar = ({
  placeholder = 'Search',
  onChange,
}: {
  placeholder?: string;
  onChange?: (query: string) => void;
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [query, setQuery] = useState('');

  useEffect(() => {
    if (onChange) {
      onChange(query);
    }
  }, [query]);

  return (
    <Container onClick={() => inputRef.current?.focus()}>
      <InputField
        ref={inputRef}
        type="text"
        placeholder="Search"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />
      {query.length > 0 ? (
        <Icon key="clear-icon" $clickable={true} onClick={() => setQuery('')}>
          <i className="icon-x" />
        </Icon>
      ) : (
        <Icon key="search-icon">
          <i className="icon-lens" />
        </Icon>
      )}
    </Container>
  );
};

const Container = styled.div`
  cursor: text;
  box-sizing: border-box;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 0 10px;

  border-radius: 15px;

  outline: 1px solid var(--neutral-3);
  &:hover {
    outline: 1px solid var(--neutral-4);
  }

  &:focus-within {
    outline: 1px solid var(--primary-1);
  }
`;

const InputField = styled.input`
  cursor: text;
  box-sizing: border-box;
  width: 100%;
  height: 30px;

  overflow: hidden;
  text-overflow: ellipsis;

  background-color: transparent;
  border: none;

  color: var(--main-1);
  font-family: var(--font-1);
  font-size: 12px;

  &:focus {
    outline: none;
  }

  &::selection {
    background: var(--primary-2);
    color: var(--main-1);
  }
`;

const Icon = styled.div<{ $clickable?: boolean }>`
  width: 30px;
  height: 30px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: var(--neutral-4);
  font-size: 16px;

  animation: fadeIn 0.3s ease-in-out;

  ${({ $clickable }) =>
    $clickable &&
    `
    cursor: pointer;

    color: var(--main-2);

    &:hover {
      color: var(--main-1);
    }
  `}
`;
